// eslint-disable-next-line no-restricted-imports -- not exported from @ant-design/icons directly
import { AntdIconProps } from "@ant-design/icons/lib/components/AntdIcon";
import { RefAttributes, useMemo } from "react";

// Not all properties of AntdIconProps are supported: see the corresponding icon definition file for the picked ones.
export type IconProps = AntdIconProps & RefAttributes<HTMLSpanElement>;

export const useAddMissingAntIconClass = (iconProps: IconProps): IconProps => {
  const className = iconProps.className ? `anticon ${iconProps.className}` : "anticon";
  return useMemo(
    () => {
      const fallbackAccessibilityProps = iconProps.title
        ? { "aria-label": iconProps.title }
        : { "aria-hidden": true };
      return ({
        ...fallbackAccessibilityProps,
        ...iconProps,
        className,
      });
    },
    [className, iconProps],
  );
};
